import { render, staticRenderFns } from "./ReportShow.vue?vue&type=template&id=14b10ba7&scoped=true"
import script from "./ReportShow.vue?vue&type=script&lang=js"
export * from "./ReportShow.vue?vue&type=script&lang=js"
import style0 from "./ReportShow.vue?vue&type=style&index=0&id=14b10ba7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b10ba7",
  null
  
)

export default component.exports